(function(){function a(){var b=document.documentElement.clientWidth;b=b>1920?1920:b;var c=b/1920*100;document.getElementsByTagName("html")[0].style.fontSize=c+"px"}a();window.onresize=a})();


// WEBPACK FOOTER //
// ./src/util/rem.js